module.exports = __webpack_public_path__ + "static/media/lohono-logo-platinum.b47f6993.svg";